/* istanbul ignore file */
import { queryProcedureResult } from 'iguazu-rpc';
import { fromJS } from 'immutable';
import getChannelInfo from '../utils/getChannelInfo';
import setPartnerQueryString from '../utils/setPartnerQueryString';

export default function requireAuth(store, type) {
  const { dispatch, getState } = store;
  return (nextState, replace, callback) => {
    const redirect = () => {
      if (global.BROWSER) {
        const state = getState();

        let { href } = window.location;
        const { pathname } = window.location;
        const pathList = pathname.split('/');
        const isUpgrade = pathList.includes('upgrade');
        const isPurchasePath = pathList.includes('purchase-path');
        const isHiltonResPath = pathList.includes('reservation-path');
        const activeLocale = state.getIn(['intl', 'activeLocale']);
        const languagePack = state.getIn(
          ['intl', 'languagePacks', activeLocale, 'axp-card-member-apply-root'],
          fromJS({})
        ).toJS();
        const { data: { 'upgrade.ltype': upgradeLType } = {} } = languagePack;

        const loginURI = type
          ? state.getIn(['config', `login.${type}`])
          : state.getIn(['config', 'login']);
        // Upgrade L Type needs to be moved to the config, intl doesn't load.
        const loginPage = loginURI.replace('{locale}', activeLocale.toLowerCase());

        if (isUpgrade && (isPurchasePath || isHiltonResPath)) {
          const queryString = setPartnerQueryString(state);
          if (queryString) href += queryString;
        }
        let destPage = `?DestPage=${encodeURIComponent(href)}`;
        if (isUpgrade && upgradeLType) {
          const channel = pathList.includes('partner') ? 'partner' : 'online';
          destPage += `&ltype=${upgradeLType.replace('$channel$', channel)}`;
        }

        const loginPageUrl = loginPage + destPage;
        /* istanbul ignore next */
        if (!getChannelInfo(state)) {
          replace({
            pathname: loginPageUrl,
          });
        }
      }
    };

    return dispatch(queryProcedureResult({
      procedureName: 'readUserSession',
      args: {},
      forceFetch: true,
    })).promise
      .then(({ data } = {}) => {
        // Logged in
        if (data && data.tokenStatus === 'VALID') {
          callback();
          return data;
        }
        // Not logged in
        redirect();
        return callback();
      })
      .catch(() => {
        redirect();
        return callback();
      });
  };
}
